<template>
  <div>
    <div class="line_text u-mg-t-4 u-mg-b-4" v-if="!(authUser.is_registed && authUser.relation!='')">
      <div class="line_text__sidebox"></div>
      <div class="line_text__text" v-if="authUser.is_registed && authUser.responce=='NG'"><p>既存のIDでログイン</p></div>
      <div class="line_text__text" v-else><p>ログイン</p></div>
      <div class="line_text__sidebox"></div>
    </div>

    <div class="">
      <!-- メールアドレス認証 -->
      <login-form class="u-mg-b-3"
      v-if="!(authUser.is_registed && authUser.relation!='')"
      :regist="regist"
      :action="action"
      :return-path="returnPath"
      :reissue-key="reissueKey"
      :regist-token="registToken"
      :from-page="fromPage"
      ></login-form>
    </div>

    <!-- 既存ユーザーの場合の表示 -->
    <div v-if="authUser.is_registed && authUser.relation!=''">
      <div class="line_text u-mg-t-4 u-mg-b-4">
        <div class="line_text__sidebox"></div>
        <div class="line_text__text"><p>既存のIDでログイン</p></div>
        <div class="line_text__sidebox"></div>
      </div>
      <div class="u-pd-r-1 u-pd-l-1">
        <!-- SNS認証 -->
        <sns-register
        register-type="signin"
        :registToken="registToken"
        :hidden-relation="authUser.relation"
        ></sns-register>
      </div>
    </div>

    <!-- 既存ユーザーの場合の表示：新規登録 -->
    <div v-if="authUser.is_registed && authUser.relation!=''">
      <div class="line_text u-mg-t-5 u-mg-b-4">
        <div class="line_text__sidebox"></div>
        <div class="line_text__text"><p>別のIDで新規会員登録</p></div>
        <div class="line_text__sidebox"></div>
      </div>
      <div class="u-pd-r-1 u-pd-l-1">
        <!-- メールアドレスで登録 -->
        <a class="btn btn-block u-mg-b-3" data-color="brand" href="/user/input">メールアドレスではじめる</a>

        <!-- SNSアカウントで登録 -->
        <sns-register
        register-type="signup"
        :regist-token="registToken"
        :hidden-relation="authUser.relation"
        ></sns-register>
      </div>
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import login from './login'
export default {
  name: 'sign-in-action-panel',
  mixins: [login],
  props: {
    registToken: { type: String, default: '' },
    fromPage: { type: String, default: '' }
  },
  computed: {
    ...mapState({
      authUser: state => state.auth.data
    })
  },
  methods: {
    calltest(){
      // console.log("calltest()");
    }
  }
}

</script>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/SignInActionPanel.vue